
import React from 'react';
import { Button } from '@/components/ui/button';
import { Phone, Mail, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import heroImage from '@/assets/hero-ai-knowledge-library.png';

const Hero: React.FC = () => {
  const navigate = useNavigate();
  
  const handleServicesClick = () => {
    navigate('/services');
  };

  return (
    <div className="pt-20 sm:pt-24 md:pt-32 pb-16 md:pb-20 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-full h-full overflow-hidden z-0">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white to-brand-blue/10"></div>
        <div className="absolute top-20 right-[-10%] w-[600px] h-[600px] bg-[#0B1939] opacity-10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-[500px] h-[500px] bg-brand-teal opacity-10 rounded-full blur-3xl"></div>
      </div>
      
      <div className="section-inner relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-left">
            <span className="inline-block bg-brand-teal text-white px-4 py-1 rounded-full text-sm font-medium mb-6 shadow-sm">
              AI-Powered Solutions for SMBs
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight text-gray-900">
              Workflow Intelligence for <span className="text-brand-teal font-bold">Future-Ready</span> Businesses
            </h1>
            <p className="text-lg sm:text-xl text-gray-700 mb-8">
              ThinkTomorrow.AI is a New Zealand AI workflow advisory firm helping small and medium businesses adopt artificial intelligence responsibly and profitably.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <div className="flex items-center justify-center gap-2 px-6 py-3 bg-brand-teal text-white font-medium rounded-lg w-full">
                <Phone size={18} />
                <span className="text-lg">0212 763 763</span>
              </div>
              
              <div className="flex items-center justify-center gap-2 px-6 py-3 border-2 border-brand-navy text-brand-navy font-medium rounded-lg w-full">
                <Mail size={18} />
                <span className="text-lg">connect@thinktomorrow.ai</span>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                variant="secondary" 
                size="lg" 
                className="w-full bg-brand-blue hover:bg-brand-blue/90 text-white"
                onClick={handleServicesClick}
              >
                <span>View Services</span>
                <ArrowRight className="ml-2" size={18} />
              </Button>
            </div>
          </div>
          
          <div className="relative">
            <div className="rounded-lg shadow-xl border border-gray-100 overflow-hidden">
              <img 
                src={heroImage}
                alt="Futuristic AI knowledge library showing organized data architecture and artificial intelligence solutions for New Zealand businesses - bird's eye view of modern technology infrastructure representing Think Tomorrow AI's strategic approach to business automation, machine learning implementation, and digital transformation consulting services" 
                className="w-full h-auto object-cover"
              />
            </div>
            
            <div className="absolute -top-4 right-4 bg-white p-2 rounded-lg shadow-lg border border-gray-100">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-xs font-medium text-gray-700">AI-Powered Growth</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
